import { render } from "./_wrapper.vue?vue&type=template&id=021b5f33&scoped=true"
import script from "./_wrapper.vue?vue&type=script&lang=js"
export * from "./_wrapper.vue?vue&type=script&lang=js"

import "./_wrapper.vue?vue&type=style&index=0&id=021b5f33&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021b5f33"]])

export default __exports__